import { _axios } from "../../Utils/Axios/axios";

export const getProductsByUserToken = async (userToken: string) => {
  return _axios.get("/u_products", {
    headers: {
      Authorization: `Bearer ${userToken}`,
    },
  });
};
